// extracted by mini-css-extract-plugin
export var wrapper = "section-principles-module--wrapper--3YZts";
export var cardsWrapper = "section-principles-module--cards-wrapper--3Hfth";